import { createFileRoute } from '@tanstack/react-router'
import { Network } from 'lucide-react'
import { ApiGatewayScreen } from '@/screens/connect/SCR-038-api-gateway'

export const Route = createFileRoute('/_app/connect/api-gateway')({
  staticData: { screen: { id: 'SCR-038', title: 'API gateway', group: 'Connect', perm: 'connector.manage', order: 8, description: 'Rules for API keys: allowed networks and websites, stricter rate limits and required purposes. Blocked calls are listed.', icon: Network } },
  component: ApiGatewayScreen,
})
